import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_31144",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_31144)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M77.4052 58.6016C77.4052 54.0346 79.1726 50.3082 81.4219 50.028L81.4219 50L34.2985 50C31.9287 50 30.0007 53.8386 30.0007 58.6017C30.0007 63.3648 31.9287 67.2034 34.2985 67.2034L81.4219 67.2034L81.4219 67.1754C79.1726 66.8951 77.4052 63.1687 77.4052 58.6016Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M77.4044 58.6017C77.4044 63.1687 79.1718 66.8952 81.4211 67.1753C81.5014 67.2033 81.6219 67.2033 81.7022 67.2033C84.072 67.2034 86 63.3648 86 58.6017C86 53.8386 84.072 50 81.7022 50C81.6219 50 81.5014 50 81.4211 50.028C79.1718 50.3082 77.4044 54.0347 77.4044 58.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.4052 41.6016C76.4052 37.0346 78.1726 33.3082 80.4219 33.028L80.4219 33L33.2985 33C30.9287 33 29.0007 36.8386 29.0007 41.6017C29.0007 46.3648 30.9287 50.2034 33.2985 50.2034L80.4219 50.2034L80.4219 50.1754C78.1726 49.8951 76.4052 46.1687 76.4052 41.6016Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.4044 41.6017C76.4044 46.1687 78.1718 49.8952 80.4211 50.1753C80.5014 50.2033 80.6219 50.2033 80.7022 50.2033C83.072 50.2034 85 46.3648 85 41.6017C85 36.8386 83.072 33 80.7022 33C80.6219 33 80.5014 33 80.4211 33.028C78.1718 33.3082 76.4044 37.0347 76.4044 41.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.4052 67.6016C69.4052 63.0346 71.1726 59.3082 73.4219 59.028L73.4219 59L26.2985 59C23.9287 59 22.0007 62.8386 22.0007 67.6017C22.0007 72.3648 23.9287 76.2034 26.2985 76.2034L73.4219 76.2034L73.4219 76.1754C71.1726 75.8951 69.4052 72.1687 69.4052 67.6016Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.4044 67.6017C69.4044 72.1687 71.1718 75.8952 73.4211 76.1753C73.5014 76.2033 73.6219 76.2033 73.7022 76.2033C76.072 76.2034 78 72.3648 78 67.6017C78 62.8386 76.072 59 73.7022 59C73.6219 59 73.5014 59 73.4211 59.028C71.1718 59.3082 69.4044 63.0347 69.4044 67.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.4052 50.6016C68.4052 46.0346 70.1726 42.3082 72.4219 42.028L72.4219 42L25.2985 42C22.9287 42 21.0007 45.8386 21.0007 50.6017C21.0007 55.3648 22.9287 59.2034 25.2985 59.2034L72.4219 59.2034L72.4219 59.1754C70.1726 58.8951 68.4052 55.1687 68.4052 50.6016Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.4044 50.6017C68.4044 55.1687 70.1718 58.8952 72.4211 59.1753C72.5014 59.2033 72.6219 59.2033 72.7022 59.2033C75.072 59.2034 77 55.3648 77 50.6017C77 45.8386 75.072 42 72.7022 42C72.6219 42 72.5014 42 72.4211 42.028C70.1718 42.3082 68.4044 46.0347 68.4044 50.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.4052 76.6016C61.4052 72.0346 63.1726 68.3082 65.4219 68.028L65.4219 68L18.2985 68C15.9287 68 14.0007 71.8386 14.0007 76.6017C14.0007 81.3648 15.9287 85.2034 18.2985 85.2034L65.4219 85.2034L65.4219 85.1754C63.1726 84.8951 61.4052 81.1687 61.4052 76.6016Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.4044 76.6017C61.4044 81.1687 63.1718 84.8952 65.4211 85.1753C65.5014 85.2033 65.6219 85.2033 65.7022 85.2033C68.072 85.2034 70 81.3648 70 76.6017C70 71.8386 68.072 68 65.7022 68C65.6219 68 65.5014 68 65.4211 68.028C63.1718 68.3082 61.4044 72.0347 61.4044 76.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.4052 59.6016C60.4052 55.0346 62.1726 51.3082 64.4219 51.028L64.4219 51L17.2985 51C14.9287 51 13.0007 54.8386 13.0007 59.6017C13.0007 64.3648 14.9287 68.2034 17.2985 68.2034L64.4219 68.2034L64.4219 68.1754C62.1726 67.8951 60.4052 64.1687 60.4052 59.6016Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.4044 59.6017C60.4044 64.1687 62.1718 67.8952 64.4211 68.1753C64.5014 68.2033 64.6219 68.2033 64.7022 68.2033C67.072 68.2034 69 64.3648 69 59.6017C69 54.8386 67.072 51 64.7022 51C64.6219 51 64.5014 51 64.4211 51.028C62.1718 51.3082 60.4044 55.0347 60.4044 59.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask1_2938_31144",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: -3,
				y: -3,
				width: 105,
				height: 105,
				children: /* @__PURE__ */ _jsx("rect", {
					x: -3,
					y: -3,
					width: 105,
					height: 105,
					fill: "#C4C4C4"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask1_2938_31144)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M48.8672 8.5C49.9832 8.50008 51.083 8.76747 52.0742 9.28027C53.0656 9.79326 53.9197 10.537 54.5645 11.4482C55.2092 12.3594 55.6264 13.412 55.7803 14.5176C55.918 15.5073 55.8397 16.5135 55.5557 17.4688H51.0967C51.3199 17.2191 51.5023 16.9338 51.6318 16.6211C51.8584 16.0742 51.9182 15.4722 51.8027 14.8916C51.6873 14.3111 51.4019 13.778 50.9834 13.3594C50.5648 12.9408 50.0308 12.6555 49.4502 12.54C48.8698 12.4247 48.2684 12.4836 47.7217 12.71C47.1747 12.9365 46.7068 13.3203 46.3779 13.8125C46.049 14.3048 45.873 14.8836 45.873 15.4756C45.8731 16.2138 46.149 16.9214 46.6387 17.4688H42.1777C41.8937 16.5135 41.8154 15.5073 41.9531 14.5176C42.107 13.412 42.5242 12.3594 43.1689 11.4482C43.8137 10.537 44.6678 9.79326 45.6592 9.28027C46.6505 8.76739 47.751 8.5 48.8672 8.5Z",
						fill: "#FDF1E6",
						stroke: "#A35705"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M37.2285 16.9912H60.6631C61.5316 16.9912 62.3368 17.6288 62.584 18.6162L68.2715 41.3779C68.8556 43.7138 67.2333 45.9111 65.1504 45.9111H32.7373C30.6544 45.911 29.0326 43.7142 29.6201 41.3789V41.3779L35.3086 18.6162C35.555 17.6298 36.3599 16.9912 37.2285 16.9912Z",
						fill: "#FDF1E6",
						stroke: "#A35705"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M45.7973 31.1219L44.6727 32.277V34.0906H43.3555V26.998H44.6727V30.6355L48.1784 26.998H49.6577L46.6789 30.1694L49.8401 34.0906H48.3L45.7973 31.1219Z",
						fill: "#A35705"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M55.748 28.68V33.2699C55.748 35.1748 54.7753 36.1272 52.8299 36.1272C52.3098 36.1272 51.8167 36.0597 51.3506 35.9246C50.8845 35.7962 50.4995 35.6071 50.1955 35.3572L50.7629 34.4047C50.9994 34.6006 51.2966 34.756 51.6546 34.8708C52.0193 34.9924 52.3875 35.0532 52.759 35.0532C53.3534 35.0532 53.7891 34.9181 54.0661 34.6479C54.343 34.3777 54.4815 33.9657 54.4815 33.4118V33.1281C54.2653 33.3645 54.0019 33.5435 53.6912 33.6651C53.3804 33.7867 53.0393 33.8475 52.6678 33.8475C52.1544 33.8475 51.6884 33.7394 51.2696 33.5232C50.8575 33.3003 50.5299 32.9896 50.2867 32.5911C50.0503 32.1925 49.9321 31.7366 49.9321 31.2232C49.9321 30.7098 50.0503 30.2573 50.2867 29.8655C50.5299 29.4669 50.8575 29.1596 51.2696 28.9434C51.6884 28.7273 52.1544 28.6192 52.6678 28.6192C53.0596 28.6192 53.4142 28.6834 53.7317 28.8117C54.0559 28.9401 54.3261 29.136 54.5423 29.3994V28.68H55.748ZM52.8603 32.7734C53.3399 32.7734 53.7317 32.6316 54.0357 32.3479C54.3464 32.0574 54.5017 31.6825 54.5017 31.2232C54.5017 30.7706 54.3464 30.4025 54.0357 30.1188C53.7317 29.8351 53.3399 29.6932 52.8603 29.6932C52.374 29.6932 51.9754 29.8351 51.6647 30.1188C51.3607 30.4025 51.2088 30.7706 51.2088 31.2232C51.2088 31.6825 51.3607 32.0574 51.6647 32.3479C51.9754 32.6316 52.374 32.7734 52.8603 32.7734Z",
						fill: "#A35705"
					})
				]
			})
		]
	})]
});
export default SvgMass;
